















































































































































































import Vue from 'vue';

// import { MDCList } from '@material/list';
// import { MDCRipple } from '@material/ripple';

interface Data {
  x: any;
}

export default Vue.extend({
  name: 'Contact',
  data(): Data {
    return {} as Data;
  },
  mounted() {
    // //   Nice view of the address book
    // this.addressesList = new MDCList(this.$el.querySelector('.addressBook .mdc-list') as HTMLElement);
    // this.addressesList.listElements.map((listItemEl) => new MDCRipple(listItemEl));
  },
  beforeDestroy() {
    // this.addressesList.destroy();
  },
  metaInfo: {
    title: buildTitle(),
    meta: [
      { name: 'Description', content: buildDescription() },
    ],
  },
  components: {},
  methods: {
    mailTo(address: string) {
      window.location.href = 'mailto:' + address;
    },
  },
});

function buildTitle(): string {
  const en = 'Contact Page';
  if (navigator.language === 'en') {
    return en;
  } else if (navigator.language === 'fr') {
    return 'Page de contact';
  }

  return en;
}

function buildDescription(): string {
  const en = 'Give us a call or send us a message, we will come back to you.';
  if (navigator.language === 'en') {
    return en;
  } else if (navigator.language === 'fr') {
    return 'Passez nous un coup de téléphone ou un message, nous vous recontacterons.';
  }

  return en;
}
